export const getUserLocationString = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject("Geolocalização não é suportada pelo navegador.");
        return;
      }
  
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          resolve(`log: ${longitude}, lat: ${latitude}`);
        },
        (error) => {
          const errorMessages: Record<number, string> = {
            1: "Permissão de localização negada.",
            2: "Localização indisponível.",
            3: "Tempo de solicitação esgotado.",
          };
  
          reject(errorMessages[error.code] || "Erro desconhecido.");
        }
      );
    });
  };
  
  (async () => {
    try {
      const locationString = await getUserLocationString();
      console.log(locationString); 
    } catch (error) {
      console.error(`Erro ao obter localização: ${error}`);
    }
  })();
  